import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { PreapredStock } from "../prepared-stock.entity";
import { MaterialPreperationRequest } from "./material-preperation.req";

export class MaterialPreperationAdapter {
    convertDtoToEntity(dtoObj: MaterialPreperationRequest,  isUpdate: boolean = false,barcode:string,productName:string ): PreapredStock {
        try {
            console.log(dtoObj)
            const entityObj = new PreapredStock();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.saleOrderId = dtoObj.saleOrderId;
            entityObj.saleOrderItemId = dtoObj.saleOrderItemId;
            entityObj.itemId =dtoObj.itemId;
            entityObj.itemBarcode = dtoObj.itemBarcode;
            entityObj.productName = productName;
            entityObj.stockId = dtoObj.stockId;
            entityObj.preparedQuantity = dtoObj.preparedQuantity;
            entityObj.unitId = dtoObj.unitId;
            entityObj.barcode = barcode;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

}